import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import TextButton from 'LuxKit/Button/TextButton'
import LineExternalLinkAltIcon from 'LuxKit/Icons/line/LineExternalLinkAltIcon'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'

const FooterContainer = styled.div`
  padding: ${rem(16)} ${rem(24)};
  background: ${props => props.theme.palette.neutral.default.eight};
  border-top: 1px solid ${props => props.theme.palette.neutral.default.five};
`

const FooterContent = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: ${rem(700)};
`

interface Props {
  heading: string
  body: string
  browseAllResultsUrl: string
  buttonLabel: string
}

function BrowseAllResultsFooter({
  heading,
  body,
  browseAllResultsUrl,
  buttonLabel,
}: Props) {
  return (
    <FooterContainer>
      <FooterContent>
        <Sheet
          padding={20}
          background="light-background"
          border="light-foreground"
          borderRadius="M"
        >
          <Group
            direction="horizontal"
            horizontalAlign="space-between"
            verticalAlign="center"
          >
            <Group direction="vertical" gap={4}>
              <Heading variant="heading5">{heading}</Heading>
              <BodyText variant="small" colour="light-foreground-alt">{body}</BodyText>
            </Group>

            <TextButton
              kind="primary"
              size="medium"
              href={browseAllResultsUrl}
              target="_blank"
              rel="noopener noreferrer"
              endIcon={<LineExternalLinkAltIcon />}
            >
              {buttonLabel}
            </TextButton>
          </Group>
        </Sheet>
      </FooterContent>
    </FooterContainer>
  )
}

export default BrowseAllResultsFooter
